// extracted by mini-css-extract-plugin
export default {"link":"SK-z","disabled":"TK-z"};